export const colors = {
    fuchasia: [
        '#fadcec',
        '#f3b5d2',
        '#f087b6',
        '#ea5297',
        '#e6007e',
        '#e6007e',
        '#e6007e',
        '#e6007e',
        '#e6007e',
        '#e6007e',
    ],
    blue: [
        '#dce7f8',
        '#b8d0ee',
        '#8fbae3',
        '#5da3d9',
        '#008fcf',
        '#2f2870', //Dark blue
        '#2f2870',
        '#2f2870',
        '#2f2870',
        '#2f2870',
    ],
    gray: [
        '#fcfcfc',
        '#e5e5e5',
        '#cacaca',
        '#aeaeae',
        '#909090',
        '#706e6f',
        '#212C36',
        '#212C36',
        '#212C36',
        '#212C36',
    ],
    text: [
        '#F9F9F9',
        '#B0B0B0',
        '#4C4C4C',
        '#4C4C4C',
        '#4C4C4C',
        '#4C4C4C',
        '#4C4C4C',
        '#4C4C4C',
        '#4C4C4C',
        '#4C4C4C',
    ],
    green: [
        '#71BB70',
        '#71BB70',
        '#71BB70',
        '#71BB70',
        '#71BB70',
        '#71BB70',
        '#71BB70',
        '#71BB70',
        '#71BB70',
        '#71BB70',
    ],
    redt: [
        '#C10D0D',
        '#C10D0D',
        '#C10D0D',
        '#C10D0D',
        '#C10D0D',
        '#C10D0D',
        '#C10D0D',
        '#C10D0D',
        '#C10D0D',
        '#C10D0D',
        '#C10D0D',
    ],
}
